import BaseReducer from "../../utilities/BaseReducer";
import UserAction from "./UserAction";

export default class UserReducer extends BaseReducer {
  //initial state of user
  initialState = {
    user: [],
  };

  //user request action finish
  [UserAction.REQUEST_USER_FINISHED](state, action) {
    return {
      ...state,
      user: action.payload,
    };
  }
}
